import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
const marqueeItems = ['🔥 SOLO POR HOY', '—', 'Sistema + 4 Bonos Gratis', '—', '⏰ OFERTA LIMITADA', '—', 'SOLO $19.999 ARS', '—', '🔥 SOLO POR HOY', '—', 'Sistema + 4 Bonos Gratis', '—', '⏰ OFERTA LIMITADA', '—', 'SOLO $19.999 ARS', '—'];
export function StickyAlertBar() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <div className="sticky-bar w-full overflow-hidden" style={{
    background: 'var(--bg-dark)'
  }} role="banner" aria-label="Oferta especial" data-id="element-365">
      <style data-id="element-366">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 18s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="flex items-center" data-id="element-367">
        {/* Scrolling ticker */}
        <div className="flex-1 overflow-hidden py-2.5" data-id="element-368">
          <div className="marquee-track" style={{
          display: 'flex',
          width: 'max-content',
          animation: 'marquee 18s linear infinite'
        }} data-id="element-369">
            {marqueeItems.map((item, i) => <span key={i} className="px-4 text-sm whitespace-nowrap" style={{
            fontFamily: 'var(--font-body)',
            color: item === '—' ? 'rgba(255,255,255,0.25)' : item.includes('$19.999') || item.includes('SOLO POR HOY') || item.includes('OFERTA') ? '#F5C842' : 'rgba(255,255,255,0.9)',
            fontWeight: item.includes('$19.999') || item.includes('SOLO POR HOY') || item.includes('OFERTA') ? 700 : 400
          }} data-id="element-370">
                {item}
              </span>)}
          </div>
        </div>

        {/* Close button — fixed right */}
        <div className="flex-shrink-0 pr-3" data-id="element-371">
          <button onClick={() => setVisible(false)} className="p-1.5 rounded-full transition-colors hover:bg-white/10" aria-label="Cerrar barra de alerta" style={{
          color: 'rgba(255,255,255,0.5)'
        }} data-id="element-372">
            <XIcon className="w-3.5 h-3.5" data-id="element-373" />
          </button>
        </div>
      </div>
    </div>;
}